export default __webpack_public_path__ + "static/media/flag.b89793c0.svg";